import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { wait } from 'Src/me/pages/guest/proposals/new/utils';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderContractorSearchInterface } from '../../views/ContractorSearchInterface';

const SECTION_KEY_NAME = 'contractorSearchInterface';

export const contractorSearchInterfaceSection = async (props: SectionsPropsType) => {
  const { userAnswers, afterFirstAnswer } = props;
  const headerElement = document.querySelector<HTMLElement>('.header');
  const footerElement = document.querySelector<HTMLElement>('.footer');

  // ヘッダーを非表示にする
  headerElement.style.display = 'none';
  footerElement.style.display = 'none';

  // オープニングページ
  await renderContractorSearchInterface({
    ...props,
    keyName: SECTION_KEY_NAME,
  });

  // ヘッダーを表示する
  headerElement.style.display = '';

  // 1回目の回答後に行う処理
  afterFirstAnswer();

  await wait(1.5);

  // アドバイザーの吹き出し
  const prefectureAnswerData = userAnswers.find((answer) => answer.paramName === 'prefecture');
  const preferredSearchCriteriaAnswerData = userAnswers.find((answer) => answer.paramName === 'preferredSearchCriteria');
  const preferredSearchKeywordAnswerData = userAnswers.find((answer) => answer.paramName === 'preferredSearchKeyword');
  const budgetAnswerData = userAnswers.find((answer) => answer.paramName === 'budget');
  const deteriorationAnswerData = userAnswers.find((answer) => answer.paramName === 'deterioration');
  const constructionCategoryAnswerData = userAnswers.find((answer) => answer.paramName === 'constructionCategory');
  const advisorMessage = () => {
    if (preferredSearchKeywordAnswerData) {
      return '人気キーワードから検索します。';
    }
    if (budgetAnswerData) {
      return '工事予算から検索します。';
    }
    if (deteriorationAnswerData) {
      return '劣化状況から検索します。';
    }
    if (preferredSearchCriteriaAnswerData) {
      const messageTable = {
        '口コミ・評判が良い': '口コミ・評判から検索します。',
        '施工件数が多い': '施工件数から検索します。',
        'コストパフォーマンスが良い': 'コストパフォーマンス重視で検索します。',
        'コスパが良い': 'コストパフォーマンス重視で検索します。',
        '設立年数': '会社情報から検索します。',
        '従業員数': '会社情報から検索します。',
        '保有資格': '会社情報から検索します。',
        '完全自社施工': '会社情報から検索します。',
        'ローン有': '利用できるサービスから検索します。',
        '各種保険完備': '利用できるサービスから検索します。',
        'アフターフォロー': '利用できるサービスから検索します。',
      };

      return messageTable?.[preferredSearchCriteriaAnswerData.answer] || '選択された内容で検索します。';
    }
    if (constructionCategoryAnswerData) {
      return '工事内容から検索します。';
    }
    return '選択された内容で検索します。';
  };

  if (!prefectureAnswerData) {
    await renderAdvisorMessage({
      ...props,
      keyName: SECTION_KEY_NAME,
      doesNotScroll: true,
      messageElement: (
        <>
          {advisorMessage()}
        </>
      ),
    });
  }
};
